import { render } from "./SearchResult.vue?vue&type=template&id=6dfa00e4"
import script from "./SearchResult.vue?vue&type=script&lang=js"
export * from "./SearchResult.vue?vue&type=script&lang=js"

import exportComponent from "C:\\repos\\CharitableBail\\CT.PublicAccess.CharitableBail.UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__